import { AxiosResponse } from 'axios'
import { APIDecoratorWithBaseURI } from './api'
import { OsAnalyticsFilters, OsListFilters, SaveOsPayload } from '../types/os'

const BASE = 'producer/analytics'

export const buildQuery = (filters: Record<string, any>): string => {
  const params = new URLSearchParams()
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params.append(key, String(value))
    }
  })
  return params.toString()
}

// ---- Leitura ----
export const getOsList = (filters: OsListFilters): Promise<AxiosResponse> =>
  APIDecoratorWithBaseURI().get(`${BASE}/getOsList?${buildQuery(filters as Record<string, any>)}`)

export const getOsDetail = (id: number): Promise<AxiosResponse> =>
  APIDecoratorWithBaseURI().get(`${BASE}/getOsDetail?id=${id}`)

export const getOsByEvento = (eventoId: number): Promise<AxiosResponse> =>
  APIDecoratorWithBaseURI().get(`${BASE}/getOsByEvento?eventoId=${eventoId}`)

export const getOsSetores = (eventoId: number): Promise<AxiosResponse> =>
  APIDecoratorWithBaseURI().get(`${BASE}/getOsSetores?eventoId=${eventoId}`)

export const getOsAnalytics = (filters: OsAnalyticsFilters): Promise<AxiosResponse> =>
  APIDecoratorWithBaseURI().get(`${BASE}/getOsAnalytics?${buildQuery(filters as Record<string, any>)}`)

export const getOsAnalyticsExport = (filters: OsAnalyticsFilters): Promise<AxiosResponse> =>
  APIDecoratorWithBaseURI().get(`${BASE}/getOsAnalyticsExport?${buildQuery(filters as Record<string, any>)}`)

// ---- Workflow ----
export const saveOs = (payload: SaveOsPayload): Promise<AxiosResponse> =>
  APIDecoratorWithBaseURI().post(`${BASE}/saveOs`, payload)

export const submitOs = (id: number): Promise<AxiosResponse> =>
  APIDecoratorWithBaseURI().post(`${BASE}/submitOs`, { id })

export const approveOs = (id: number): Promise<AxiosResponse> =>
  APIDecoratorWithBaseURI().post(`${BASE}/approveOs`, { id })

export const rejectOs = (id: number, motivo: string): Promise<AxiosResponse> =>
  APIDecoratorWithBaseURI().post(`${BASE}/rejectOs`, { id, motivo })

export const reopenOs = (id: number): Promise<AxiosResponse> =>
  APIDecoratorWithBaseURI().post(`${BASE}/reopenOs`, { id })

export const importOs = (id: number): Promise<AxiosResponse> =>
  APIDecoratorWithBaseURI().post(`${BASE}/importOs`, { id })

export const reverterImportOs = (id: number): Promise<AxiosResponse> =>
  APIDecoratorWithBaseURI().post(`${BASE}/reverterImportOs`, { id })

export const importOsParcial = (id: number): Promise<AxiosResponse> =>
  APIDecoratorWithBaseURI().post(`${BASE}/importOsParcial`, { id })

// ---- Logística de Equipamentos ----
export const saveOsCustoLogistica = (payload: {
  osId: number
  data: string
  descricao: string
  valor: number
}): Promise<AxiosResponse> => APIDecoratorWithBaseURI().post(`${BASE}/saveOsCustoLogistica`, payload)

export const deleteOsCustoLogistica = (osId: number, id: number): Promise<AxiosResponse> =>
  APIDecoratorWithBaseURI().delete(`${BASE}/deleteOsCustoLogistica?osId=${osId}&id=${id}`)

// ---- Técnicos ----
export const getOsTecnicos = (search?: string): Promise<AxiosResponse> =>
  APIDecoratorWithBaseURI().get(`${BASE}/getOsTecnicos${search ? `?search=${encodeURIComponent(search)}` : ''}`)

export const getOsTecnico = (id: number): Promise<AxiosResponse> =>
  APIDecoratorWithBaseURI().get(`${BASE}/getOsTecnico?id=${id}`)

export const saveOsTecnico = (payload: Record<string, any>): Promise<AxiosResponse> =>
  APIDecoratorWithBaseURI().post(`${BASE}/saveOsTecnico`, payload)

export const deleteOsTecnico = (id: number): Promise<AxiosResponse> =>
  APIDecoratorWithBaseURI().delete(`${BASE}/deleteOsTecnico?id=${id}`)

// ---- Config ----
export const getOsConfig = (): Promise<AxiosResponse> =>
  APIDecoratorWithBaseURI().get(`${BASE}/getOsConfig`)

export const saveOsConfig = (payload: Record<string, any>): Promise<AxiosResponse> =>
  APIDecoratorWithBaseURI().post(`${BASE}/saveOsConfig`, payload)

// ---- Anexos ----
export const createOsAnexoUrl = (
  osId: number,
  contentType: string,
): Promise<AxiosResponse> =>
  APIDecoratorWithBaseURI().post(`${BASE}/createOsAnexoUrl`, { osId, contentType })

export const saveOsAnexo = (payload: Record<string, any>): Promise<AxiosResponse> =>
  APIDecoratorWithBaseURI().post(`${BASE}/saveOsAnexo`, payload)

export const deleteOsAnexo = (id: number): Promise<AxiosResponse> =>
  APIDecoratorWithBaseURI().delete(`${BASE}/deleteOsAnexo?id=${id}`)

export const createOsTecnicoDocUrl = (contentType: string): Promise<AxiosResponse> =>
  APIDecoratorWithBaseURI().post(`${BASE}/createOsTecnicoDocUrl`, { contentType })
